import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {PermissionArea} from '../../enums/permission-area.enum';
import {IconCode} from '../../enums/icon-code.enum';

@Injectable()
export class NavSalesCpiFactory extends NavFactory {

    protected static items = [
        {
            code: NavItemCodes.SALES_CPI_PRODUCT_PICK,
            icon: IconCode.SALES_CPI_PRODUCT_PICK,
            label: 'NAV.POLICY_CPI_ADD.LABEL',
            description: 'NAV.POLICY_CPI_ADD.DESC',
            path: '/sales/cpi/product-pick',
            permissionArea: PermissionArea.SALES_CPI,
            cy: 'sales-cpi'
        },
        {
            code: NavItemCodes.SALES_CPI_OFFER_QUESTIONNAIRE,
            label: 'LABELS.CUSTOMER_NEEDS_SURVEY',
            icon: IconCode.SALES_CPI_OFFER_SIMULATE,
            path: ({offerId}) => ['/sales/cpi/offer', offerId, 'questionnaire'],
            permissionArea: PermissionArea.SALES_CPI,
        },
        {
            code: NavItemCodes.SALES_CPI_OFFER_SIMULATE,
            label: 'NAV.POLICY_CPI_OFFER_SIMULATE.LABEL',
            icon: IconCode.SALES_CPI_OFFER_SIMULATE,
            path: ({offerId}) => ['/sales/cpi/offer', offerId, 'init'],
            permissionArea: PermissionArea.SALES_CPI,
        },
        {
            code: NavItemCodes.SALES_CPI_OFFER_DATA,
            label: 'NAV.POLICY_CPI_OFFER_DATA.LABEL',
            icon: IconCode.SALES_CPI_OFFER_DATA,
            path: ({offerId}) => ['/sales/cpi/offer', offerId, 'data'],
            permissionArea: PermissionArea.SALES_CPI,
        },
    ];
}
